import { render, staticRenderFns } from "./UserNavbar.vue?vue&type=template&id=5621a8dc&scoped=true&"
import script from "./UserNavbar.vue?vue&type=script&lang=js&"
export * from "./UserNavbar.vue?vue&type=script&lang=js&"
import style0 from "./UserNavbar.vue?vue&type=style&index=0&id=5621a8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621a8dc",
  null
  
)

export default component.exports